var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignmentResumed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41714",
    "data-name": "Group 41714",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "inactive_order_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "inactive_order_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M122.7-835.044h10.786V-836.4H122.7ZM133.764-822a4.035,4.035,0,0,1-2.978-1.25,4.072,4.072,0,0,1-1.236-2.962,4.12,4.12,0,0,1,1.236-3.012,4.056,4.056,0,0,1,2.989-1.245,4.067,4.067,0,0,1,2.978,1.245A4.1,4.1,0,0,1,138-826.213a4.054,4.054,0,0,1-1.247,2.962A4.072,4.072,0,0,1,133.764-822ZM120-822.9v-15.747a1.3,1.3,0,0,1,.4-.955,1.3,1.3,0,0,1,.952-.4h13.483a1.3,1.3,0,0,1,.952.4,1.3,1.3,0,0,1,.4.955v7.367a4.566,4.566,0,0,0-.654-.257,6.365,6.365,0,0,0-.695-.171v-6.939H121.348v13.494h6.966a4.11,4.11,0,0,0,.2.779,7.234,7.234,0,0,0,.316.73l-.742.743-1.348-1.352-1.348,1.352-1.348-1.352L122.7-822.9l-1.348-1.352Zm2.7-4.483h5.669q.084-.36.185-.7a3.126,3.126,0,0,1,.281-.653H122.7Zm0-3.83h8.629a5.538,5.538,0,0,1,1.034-.394,6.057,6.057,0,0,1,1.124-.191v-.766H122.7Zm-1.348,6.06v0Z",
    transform: "translate(-120 840)",
    fill: "#5ed142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "play_arrow_FILL0_wght400_GRAD0_opsz48",
    d: "M320-761.478V-763l1.066.761ZM320.145-762.239Zm0,.465.652-.465-.652-.465Z",
    transform: "translate(-306.671 775.681)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentResumed);
export default __webpack_public_path__ + "static/media/AssignmentResumed.d98216fd89716d025f5a4a5aab24b588.svg";
export { ForwardRef as ReactComponent };